export default "__VITE_ASSET__DcVQOhiC__"